import { createContext } from "react";
import { LeaderboardTeam } from "../types/leaderboard";
import {
  IStaff,
  ITeamInfo,
  ITeamScores,
  IMatch,
  Localization,
  UpcomingMatch,
} from "../types/types";
import { HistoryChartPoint } from "../utils/leaderboard/history-chart";

type MatchesContextType = {
  upcomingMatches: UpcomingMatch[] | undefined;
  playedMatches: IMatch[] | undefined;
  playoffMatches: UpcomingMatch[] | undefined;
  loading: boolean;
};

const baseMatchContext: MatchesContextType = {
  upcomingMatches: undefined,
  playedMatches: undefined,
  playoffMatches: undefined,
  loading: true,
};

interface IScoreboardContext {
  regularTeams: ITeamScores[];
}

export type LeaderboardTeamMeta = {
  teamName: string;
  fullName: string;
  logoUrl: string;
};

export type LeaderboardContextType = {
  teams: LeaderboardTeam[];
  standingsLoading: boolean;
  chartData: HistoryChartPoint[];
  chartTeams: string[];
  chartLoading: boolean;
  teamMetaById: Record<string, LeaderboardTeamMeta>;
  lastUpdated: string | null;
  live: boolean;
  error: string | null;
};

const baseLeaderboardContext: LeaderboardContextType = {
  teams: [],
  standingsLoading: true,
  chartData: [],
  chartTeams: [],
  chartLoading: true,
  teamMetaById: {},
  lastUpdated: null,
  live: true,
  error: null,
};

export const LocalizationContext = createContext<Localization>(Localization.Finnish);

export const MatchesContext = createContext<MatchesContextType>(baseMatchContext);

export const ScoreboardContext = createContext<IScoreboardContext>({
  regularTeams: [],
});

export const StaffContext = createContext<IStaff[] | undefined>(undefined);

export const TeamsContext = createContext<ITeamInfo[] | undefined>(undefined);

export const LeaderboardContext = createContext<LeaderboardContextType>(baseLeaderboardContext);
